import { Skeleton, TableCell, TableRow } from "@mui/material";

interface ITableRowsSkeleton {
    nbColumns: number;
    nbRows: number;
}

/**
 * Skeleton for a table. Creates as many rows and columns as passed.
 */
const TableRowsSkeleton = ({ nbColumns = 2, nbRows = 1 }: ITableRowsSkeleton) => {
    const loadingTableRows = [...Array(nbRows).keys()];
    const loadingTableColumns = [...Array(nbColumns).keys()];
    return (
        <>
            {loadingTableRows.map((row, i) => {
                return (
                    <TableRow key={`row-${i}`}>
                        {loadingTableColumns.map((column, j) => {
                            return (
                                <TableCell key={`column-${j}`}>
                                    <Skeleton />
                                </TableCell>
                            );
                        })}
                    </TableRow>
                );
            })}
        </>
    );
};

export default TableRowsSkeleton;
